// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered {
  position: absolute;
  background-color: transparent !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.CaptchaDiv {
  font: bold 17px verdana, arial, sans-serif;
  font-style: italic;
  color: #000000;
  padding: 4px;
  border-radius: 4px;
}

.input_with_icon {
  position: relative;
}

.pass_icon {
  position: absolute;
  right: 2%;
  top: 30%;
}

.CaptchaInput {
  margin: 1px 0px 1px 0px;
  width: 135px;
}

.custom-captcha {
  color: white !important;
  background: none;
  margin-top: 3px;
  margin-bottom: 0px;
  border: none;
  font-style: italic;
  font-size: 26px;
  margin-left: 3em;
  pointer-events: none;
  padding-left: 19px !important;
}

button.btn.btn-primary.recover-pass {
  color: #fff !important;
}

.fm {
  overflow: hidden !important;
}

.captchaicon {
  vertical-align: middle;
  border-style: none;
  cursor: pointer;
}

.label-captcha {
  width: 80px;
  margin-top: -8px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.danger {
  color: #ff586b !important;
  text-transform: capitalize;
}

.form-group label {
  margin-bottom: 0.1rem;
}

.form-group {
  margin-bottom: 0.5rem;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 460px) {
  .centered {
    font-size: 23px;
    top: 50%;
    font-size: 14px !important;
    left: 36%;
  }
  .icon.captchaicon {
    width: 20px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 399px) {
  .chgpwd-captcha {
    width: 72% !important;
    height: 27px;
  }
  .form-actions {
    text-align: center !important;
  }
  .form-actions button {
    margin-bottom: 10px;
  }
}
@media only screen and (min-device-width: 400px) and (max-device-width: 720px) {
  .chgpwd-captcha {
    width: 84% !important;
    height: 40px;
  }
}
@media only screen and (max-width: 320px) {
  .chgpwd-captcha {
    width: 77% !important;
    height: 40px;
  }
}
form label {
  text-transform: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/changepassword/changepassword.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,wCAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAEA;EACE,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EAGA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACA,kBAAA;EACE,SAAA;EACA,QAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,0BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AACA;EACI;IACE,eAAA;IACA,QAAA;IACA,0BAAA;IACA,SAAA;EAEJ;EAAE;IACE,WAAA;EAEJ;AACF;AACA;EACE;IACK,qBAAA;IACC,YAAA;EACN;EACI;IACE,6BAAA;EACN;EACI;IACE,mBAAA;EACN;AACF;AAEA;EACE;IACK,qBAAA;IACC,YAAA;EAAN;AACF;AAIA;EACE;IACK,qBAAA;IACC,YAAA;EAFN;AACF;AAKA;EACE,+BAAA;AAHF","sourcesContent":[".centered {\n  position: absolute;\n  background-color: transparent !important;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.CaptchaDiv {\n  font: bold 17px verdana, arial, sans-serif;\n  font-style: italic;\n  color: #000000;\n  padding: 4px;\n  -moz-border-radius: 4px;\n  -webkit-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.input_with_icon{\n  position: relative;\n}\n\n.pass_icon{\nposition: absolute;\n  right: 2%;\n  top: 30%;\n}\n\n.CaptchaInput {\n  margin: 1px 0px 1px 0px;\n  width: 135px;\n}\n\n.custom-captcha {\n  color: white !important;\n  background: none;\n  margin-top: 3px;\n  margin-bottom: 0px;\n  border: none;\n  font-style: italic;\n  font-size: 26px;\n  margin-left: 3em;\n  pointer-events: none;\n  padding-left: 19px !important;\n}\n\nbutton.btn.btn-primary.recover-pass {\n  color: #fff !important;\n}\n\n.fm {\n  overflow: hidden !important;\n}\n\n.captchaicon {\n  vertical-align: middle;\n  border-style: none;\n  cursor: pointer;\n}\n\n.label-captcha {\n  width: 80px;\n  margin-top: -8px;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.danger {\n  color: #ff586b !important;\n  text-transform: capitalize;\n}\n\n.form-group label{\n  margin-bottom: 0.1rem;\n}\n.form-group {\n  margin-bottom: 0.5rem;\n}\n\n@media only screen and (min-device-width : 320px) and (max-device-width : 460px) {\n    .centered{\n      font-size: 23px;\n      top: 50%;\n      font-size: 14px !important;\n      left: 36%;\n    }\n    .icon.captchaicon{\n      width: 20px;\n    }\n}\n\n@media only screen and (min-device-width : 320px) and (max-device-width : 399px) {\n  .chgpwd-captcha  {\n       width: 72% !important;\n        height: 27px;\n      }\n      .form-actions{\n        text-align: center!important;\n      }\n      .form-actions button{\n        margin-bottom: 10px;\n      }\n}\n\n@media only screen and (min-device-width : 400px) and (max-device-width :720px) {\n  .chgpwd-captcha  {\n       width: 84% !important;\n        height: 40px;\n      }\n\n     \n}\n@media only screen and  (max-width :320px) {\n  .chgpwd-captcha  {\n       width: 77% !important;\n        height: 40px;\n      }\n    }\n    \nform label { \n  text-transform: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
